"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var PromotionBalloon = function (props) {
    var withIcon = props.withIcon === undefined || props.withIcon;
    return (React.createElement("div", { className: (0, classnames_1.default)('estimateEntryBanner-PromotionBalloon', "estimateEntryBanner-PromotionBalloon-".concat(props.position)) },
        withIcon && (React.createElement("div", { className: "estimateEntryBanner-PromotionBalloon_IconWrapper" },
            React.createElement("i", { className: classnames_1.default.apply(void 0, __spreadArray(['i', 'taxonomy', 'icon'], (props.categoryIconClasses || []), false)) }))),
        React.createElement("div", { className: "estimateEntryBanner-PromotionBalloon_Body" },
            "\u3042\u306A\u305F\u306E",
            React.createElement("span", { className: "estimateEntryBanner-Text-bold" }, props.categoryName),
            "\u306E",
            React.createElement("br", null),
            "\u8CB7\u53D6\u4FA1\u683C\u3092",
            React.createElement("span", { className: "estimateEntryBanner-Text-accent" },
                "\u6700\u5927",
                props.maxEstimateRequestSize,
                "\u793E\u304C\u4E00\u62EC\u67FB\u5B9A\uFF01"))));
};
exports.default = PromotionBalloon;
